import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetLevelsList = async function(language) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/levels`,
            params: { lang: language },
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetPoolsList = async function({ locationPublicId, parameters }) {
    const queryUrl = '?' + qs.stringify(parameters)

    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationPublicId}/teaching-areas${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetTeachersList = async function({
    locationPublicId,
    parameters,
}) {
    const queryUrl = '?' + qs.stringify(parameters)

    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationPublicId}/teams/teachers${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetUnitsList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)

    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/locations${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetUnitsListSimple = async function(params) {
    const queryUrl = '?' + qs.stringify(params)

    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/locations/simple-list${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetPlansList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)

    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/plans${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetCustomerSuccessList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)

    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/staff/assessors${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetPedagogicTypeList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)

    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/pedagogic-type${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetGoalsList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/goals${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}
export const GetContentsList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/contents${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}
export const GetStaffList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/staff${queryUrl}`,
            data: params,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

// export const GetClientsList = async function(locationId, params) {
export const GetClientsList = async function(params) {
    const queryUrl = '?' + qs.stringify(params)
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/clients${queryUrl}`,
            data: params,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetPartnersList = async function(locationPublicId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)

        const url = `${baseUrl}/partners/${locationPublicId}/allowed${queryUrl}`

        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}
export const GetLanguageList = async function() {
    try {
        const url = `${baseUrl}/languages`
        return await withHeadersInstance({
            method: 'get',
            url: url,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetStudentList = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/students${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}
